import React, { CSSProperties } from "react"
import { colors, fonts, glyphs } from "../Styles"

// Buttonstyles (CSS) used: 
// ...css.button_FitContent
// ...css.button_TextUnderline
// ...css.button_PositionStartEnhancerStart

export enum ButtonTypes {
  primaryButton ="primaryButton",
  textButton = "textButton",
  tableButton = "tableButton",
  tabButton = "tabButton",
  globalMenuButton = "globalMenuButton",
  cardButton = "cardButton",
}

export const CreateButtonStyle = (  buttonType?: ButtonTypes,
  overrides?: {
    baseButton?: CSSProperties,
    hoverStyles?: CSSProperties,
    startEnhancerStyles?: CSSProperties,
    endEnhancerStyles?: CSSProperties,
    hoverEnhancerStyles?: CSSProperties,
    contentStyles?: CSSProperties,
    subContentStyles?: CSSProperties,
    hoverSubContentStyles?: CSSProperties,
    disabledStyles?: CSSProperties,
  }
) => {
  const merge = (defaultStyles: CSSProperties, overrideStyles?: CSSProperties) => ({
    ...defaultStyles,
    ...(overrideStyles || {}),
  });
  
  let baseStyles = {} as CSSProperties
  let hoverStyles = {} as CSSProperties
  let startEnhancerStyles = {} as CSSProperties
  let endEnhancerStyles = {} as CSSProperties
  let contentStyles = {} as CSSProperties
  let subContentStyles = {} as CSSProperties
  let hoverSubContentStyles = {} as CSSProperties
  let hoverEnhancerStyles = {} as CSSProperties
  let disabledStyles = {} as CSSProperties

  switch (buttonType) {
    case ButtonTypes.textButton:
      baseStyles = { 
        width: "fit-content",
        height: "fit-content",
        backgroundColor: "transparent",
        padding: "0px",
      }
      hoverStyles = { 
        opacity: "0.5",
        transition: "0.2s ease"
      }
      startEnhancerStyles = {
        marginRight: "5px"
      }
      endEnhancerStyles = {
        marginLeft: "5px"
      }
      contentStyles = {
        color: colors.greyLightTertiary,
        ...fonts.header,
        ...fonts.fontSize3,
      }
      subContentStyles = {
        color: colors.greyDarkPrimary,
        ...fonts.fontSize3,
        ...fonts.header,
        textAlign: "left"
      }
    break
    case ButtonTypes.tableButton:
      baseStyles = { 
        display: "flex",
        flexDirection: "column",
        width: "fit-content",
        minWidth: "50px",
        height: "50px",
        justifyContent: "end",
        padding: "0px 5px 2px 5px",
        borderRadius: "8px 8px 0px 0px",
        backgroundColor: colors.greySecondary,
      }
      hoverStyles = {
        transition: "0.2s ease",
        backgroundColor: colors.greyPrimary
      }
      contentStyles = {
        ...fonts.header,
        ...fonts.fontSize4,
        color: colors.greyLightTertiary
      }
      startEnhancerStyles = {
        margin: "0px 0px 5px 0px"
      }
    break
    case ButtonTypes.tabButton:
      baseStyles = {
        width: "fit-content",
        height: "40px",
        backgroundColor: colors.greyDarkPrimary,
        justifyContent: "center",
        borderRadius: "8px 8px 0px 0px",
        color: colors.greyLightTertiary,
        textDecoration: "none",
        display: "flex",
        alignItems: "center",
        padding: "0px 10px",
        boxSizing: "border-box",
        paddingTop: "5px"
      }
      hoverStyles = {
        backgroundColor: colors.blueDarkPrimary,
        height: "45px",
        paddingTop: "0px"
      }
      contentStyles = {
        ...fonts.header,
        ...fonts.textShadow,
        ...fonts.fontSize4,
      }
    break
    case ButtonTypes.globalMenuButton:
      baseStyles = {
        width: "130px",
        height: "80px",
        backgroundColor: colors.greyDarkPrimary,
        gap: "5px",
        padding: "0px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        color: colors.greyLightTertiary
      }
      hoverStyles = {
        backgroundColor: colors.blueDarkPrimary
      }
      startEnhancerStyles = {
        margin: "0px",
      }
      endEnhancerStyles = {
        margin: "0px",
      }
      hoverEnhancerStyles = {
        filter: "brightness(1.5)"
      }
      contentStyles = {
        color: colors.greyLightTertiary,
        ...fonts.header,
        ...fonts.textShadow, 
        ...fonts.fontSize4,
        textAlign: "center"
        }
    break
    case ButtonTypes.cardButton:
      baseStyles = {
        cursor: "pointer", 
        minWidth: "320px", 
        width: "100%",
        height: "200px", 
        marginBottom: "20px", 
        backgroundColor: colors.greyPrimary, 
        border: "5px solid "+colors.greyPrimary,
        borderRadius: "10px", 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        justifyContent: "center",
        transition: '0.3s',
        filter: 'opacity(1)',
        boxSizing: "border-box"
      }
      hoverStyles = {
        filter: 'opacity(0.3)', 
        backgroundColor: colors.greyPrimary
      }
      contentStyles = {
        ...fonts.header,
        color: colors.greyLightTertiary,
        ...fonts.fontSize3
      }
      subContentStyles = {
        color: colors.greyLightTertiary,
        ...fonts.fontSize4,
        ...fonts.paragraph
      }
    break
    case ButtonTypes.primaryButton:
    default:
      baseStyles = { 
        width: "270px",
        height: "50px",
        backgroundColor: colors.greyDarkPrimary,
        padding: "0 10px",
        justifyContent: "center",
        position: "relative"
      }
      hoverStyles = { 
        color: colors.greyLightTertiary+"!important",
        backgroundColor: colors.blackPrimary 
      }
      contentStyles = {
        ...fonts.header,
      color: colors.greyLightTertiary,
      ...fonts.textShadow, 
      ...fonts.fontSize4,
      textAlign: "center"
      }
      subContentStyles = {
        color: colors.greyPrimary,
        ...fonts.textShadow, 
        ...fonts.fontSize4,
        textAlign: "center",
        ...fonts.paragraph
        }
      hoverSubContentStyles = {
        color: colors.greyLightTertiary,
      }
    break
  }
  return {
    baseStyles: merge(baseStyles, overrides?.baseButton),
    hoverStyles: merge(hoverStyles, overrides?.hoverStyles),
    startEnhancerStyles: merge(startEnhancerStyles, overrides?.startEnhancerStyles),
    endEnhancerStyles: merge(endEnhancerStyles, overrides?.endEnhancerStyles),
    contentStyles: merge(contentStyles, overrides?.contentStyles),
    subContentStyles: merge(subContentStyles, overrides?.subContentStyles),
    hoverSubContentStyles: merge(hoverSubContentStyles, overrides?.hoverSubContentStyles),
    hoverEnhancerStyles: merge(hoverEnhancerStyles, overrides?.hoverEnhancerStyles),
    disabledStyles: merge(disabledStyles, overrides?.disabledStyles)
  }
}